function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#D80027"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.37812 4.86865L5.06875 6.99365H7.30312L5.49687 8.30928L6.1875 10.4343L4.37812 9.12178L2.56875 10.4343L3.2625 8.30928L1.45312 6.99365H3.6875L4.37812 4.86865Z",
  fill: "#FFDA44"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.48397 12.3906L8.95585 11.7406L8.17461 12.0437L8.62773 11.3406L8.09961 10.6875L8.90898 10.9031L9.36523 10.2L9.40898 11.0375L10.2215 11.2531L9.4371 11.5531L9.48397 12.3906Z",
  fill: "#FFDA44"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.534 10.4843L10.784 9.68433L10.0996 9.19995L10.9371 9.18745L11.184 8.38745L11.4559 9.1812L12.2934 9.17183L11.6215 9.67183L11.8902 10.4656L11.2059 9.9812L10.534 10.4843Z",
  fill: "#FFDA44"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9504 5.87185L11.5816 6.62498L12.1816 7.20935L11.3535 7.0906L10.9848 7.8406L10.841 7.0156L10.0098 6.89685L10.7535 6.50623L10.6098 5.6781L11.2098 6.26248L11.9504 5.87185Z",
  fill: "#FFDA44"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.50645 3.59058L9.44395 4.42495L10.2221 4.74058L9.40645 4.94058L9.34707 5.77808L8.90645 5.06558L8.09082 5.26558L8.63145 4.62495L8.1877 3.91558L8.96582 4.2312L9.50645 3.59058Z",
  fill: "#FFDA44"
});
const SvgChina = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgChina, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/china.43aceb54.svg";
export { ForwardRef as ReactComponent };